import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const LoadingSpinner = ({ size = 'md', className }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  }

  return <Loader2 className={cn('animate-spin', sizeClasses[size], className)} />
}

interface InlineLoadingProps {
  text?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const InlineLoading = ({
  text = 'Loading...',
  size = 'md',
  className
}: InlineLoadingProps) => {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <LoadingSpinner size={size} />
      <span className="text-muted-foreground text-sm">{text}</span>
    </div>
  )
}
